export const PACKAGE_NAME = "@devforce/trailhead-client-env";
export function get(key) {
    return state.env[key];
}
export function set(key, value) {
    state.env[key] = value;
    for (let handler of state.handlers) {
        handler(key, value);
    }
}
export function registerChangeHandler(handler) {
    state.handlers.push(handler);
    return () => {
        state.handlers = state.handlers.filter((h) => h !== handler);
    };
}
let state = {
    env: {
        DEBUG: true,
        API_HOST: "",
        COMMUNITY_API_HOST: "https://th-community-api-dev.herokuapp.com/graphql",
        EXPERIENCE_API_HOST: "https://th-mobile-bff-dev.herokuapp.com/graphql",
        GRAPHQL_API_HOST: "",
        TBID_COMMUNITY_URL: "https://trailblazer.me",
        TBID_PROFILE_URL: "https://www-qa1.salesforce.com/trailblazer/",
        USE_BADGE_LABELS: false,
    },
    handlers: [],
};
export function initializeState(currentState, existingState) {
    if (existingState) {
        for (let [key, value] of Object.entries(currentState.env)) {
            // @ts-ignore
            if (typeof existingState.env[key] === "undefined") {
                // @ts-ignore
                existingState.env[key] = value;
            }
        }
        return existingState;
    }
    return currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
